/**
 * Shared Shopify OAuth helpers.
 *
 * Single source of truth for the OAuth authorize URL so the integrations page
 * and the guided setup flow can never diverge.
 */

const API_BASE = import.meta.env.VITE_API_URL || 'https://api.tagada.io';

/** The scope line merchants copy into the Shopify Dev Dashboard. */
export { SHOPIFY_SCOPE_LINE as SHOPIFY_REQUIRED_SCOPES } from '../../../../../src/lib/shopify/scopes';

/** App URL for the Shopify Dev Dashboard configuration */
export const SHOPIFY_APP_URL = import.meta.env.VITE_SHOPIFY_APP_URL ?? API_BASE;

/** Redirect URL to register in the Shopify app's allowed redirect URLs */
export const SHOPIFY_REDIRECT_URL =
  import.meta.env.VITE_SHOPIFY_REDIRECT_URL ?? `${API_BASE}/api/public/oauth/shopify/callback`;

/**
 * The backend authorize route for a connect session opened by
 * `integrations.createShopifyConnectSession`: the session id is all the URL carries, so the app
 * secret never travels in it. Prefers the local tunnel base URL in dev (Shopify must reach the callback).
 */
export function buildShopifyOAuthAuthorizeUrl(sessionId: string): string {
  const apiBaseUrl =
    import.meta.env.VITE_LOCAL_TUNNEL_BASE_URL || import.meta.env.VITE_API_URL || 'https://api.tagada.io';

  const oauthUrl = new URL(`${apiBaseUrl}/api/public/oauth/shopify/authorize`);
  oauthUrl.searchParams.set('session', sessionId);
  return oauthUrl.toString();
}
